// Banners of each page, explaining that page. <PageBanner /> (components/PageBanner.jsx) shows them
// in the page header and slides through them; the navbar strip only rotates the app-wide banners.
// Keyed by the first path segment, so /vpnservers/:serverId uses the VPN servers banners too.
// The first banner of a page is shown first. Any 520x44 image works (SVG/PNG/JPG).
const b = (file, alt) => ({ src: `/assets/banners/page-${file}.svg`, alt })

export const PAGE_BANNERS = {
  dashboard: [
    b('dashboard', 'Dashboard: outposts, users and applications at a glance'),
    b('dashboard-2', 'Download reports: export the activity reports in one click'),
    b('dashboard-3', 'Live status: online outposts and users, updated as they connect'),
  ],
  unit: [
    b('units', 'Units: commands, regiments, companies and outposts'),
    b('units-2', 'Build the tree: add commands, regiments, companies and outposts'),
    b('units-3', 'Outpost status: see which outposts are connected right now'),
    b('units-4', 'Calibrate: set the true north and distance rate of each outpost'),
  ],
  application: [
    b('applications', 'Applications: upload and release versions for every outpost'),
    b('applications-2', 'Release versions: upload, activate and download any version'),
    b('applications-3', 'Edit anytime: change only the version or status, no new file needed'),
  ],
  connectlog: [
    b('connect-log', 'Connect log: who connected, from where and when'),
    b('connect-log-2', 'Search the log: filter by name, email, unit, IP or message'),
    b('connect-log-3', 'Connection history: look back through every connection'),
  ],
  region: [
    b('regions', 'Regions: no-fly zones and airports on one map'),
    b('regions-2', 'Draw regions: polygon, rectangle or circle, drawn right on the map'),
    b('regions-3', 'Airports: add airports and see them on the radar too'),
  ],
  vpnservers: [
    b('vpn-servers', 'VPN servers: servers, addresses and their live status'),
    b('vpn-servers-2', 'Manage servers: add, edit and review every VPN server'),
    b('vpn-servers-3', 'Server status: keep an eye on each server at a glance'),
  ],
  vpnserverips: [
    b('vpn-server-ips', 'VPN server IPs: addresses assigned to each VPN server'),
    b('vpn-server-ips-2', 'Edit addresses: change the IPs assigned to a server'),
    b('vpn-server-ips-3', 'Per server: open a server to see only its own addresses'),
  ],
  vpnconnectlog: [
    b('vpn-connect-logs', 'VPN connect logs: every tunnel connect and disconnect'),
    b('vpn-connect-logs-2', 'Search the logs: device, country, ISP, IP or error'),
    b('vpn-connect-logs-3', 'Trace errors: find out why a tunnel failed to connect'),
  ],
}
